import request from "../../axios";

/**
 * @Description: 查询【获取全部应用软件分类】列表
 */
export function selectApplystypeList() {
  return request({
    method: 'post',
    url: '/api/Applys/selectApplystypeList',
    params: {}
  })
}

/**
 * @Description: 查询【获取全部逻辑组件分类】列表
 */
export function selectLogicAppTypeList() {
  return request({
    method: 'post',
    url: '/api/LogicalComponent/selectLogicalComponentTypeList',
    params: {}
  })
}

/**
 * @Description: 查询【获取全部协议组件分类】列表
 */
export function selectProtocolAppTypeList() {
  return request({
    method: 'post',
    url: '/api/ProtocolComponent/selectProtocolComponentTypeList',
    params: {}
  })
}

/**
 * @Description: 查询【获取全部设备类型】列表
 */
export function selectDevicetypeList(data) {
  return request({
    method: 'post',
    url: '/api/Applys/selectDevicetypeList',
    params: data
  })
}

/**
 * @Description: 查询【获取全部设备协议】列表
 */
export function selectDeviceprotocolList() {
  return request({
    method: 'post',
    url: '/api/Applys/selectDeviceprotocolList',
    params: {}
  })
}


